let token = null;
let tokenWaiters = []; // queue of pending calls waiting for token

let logout = ()=>{console.log("loggin not connected yet")}
const BASE_URL = "https://kort.orbyte.se/api"; // your backend URL

/**
 * Set the JWT token for API calls
 * @param {string|null} inToken
 */
export function setApiToken(inToken) {
    token = inToken;

    // resolve any pending API calls waiting for the token
    if (inToken && tokenWaiters.length) {
        tokenWaiters.forEach((resolve) => resolve(inToken));
        tokenWaiters = [];
    }
}

export function setLogoutFunktion(func){
    logout = func;
}

/**
 * Waits until a token is available, or times out
 * @param {number} timeoutMs
 * @returns {Promise<string>}
 */
function waitForToken(timeoutMs = 5000) {
    return new Promise((resolve, reject) => {
        if (token) return resolve(token);

        const timer = setTimeout(() => {
            reject(new Error("Timeout waiting for authentication token"));
        }, timeoutMs);

        tokenWaiters.push((tok) => {
            clearTimeout(timer);
            resolve(tok);
        });
    });
}

/**
 * Universal API call
 * @param {string} path - API path (e.g. "/users")
 * @param {object} options - { method: "GET"|"POST"|"PUT"|"DELETE" }
 * @param {object|null} body - Request body (for POST/PUT)
 */
export async function apiCall(path, options = { method: "GET" }, body = null) {
    const url = `${BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
    const method = options.method?.toUpperCase() || "GET";

    // ✅ Only allow unauthenticated access to `/auth/...` endpoints
    const isAuthEndpoint = /^\/?auth\//i.test(path);

    // 🔒 Wait for token if needed (for up to 5 seconds)
    if (!isAuthEndpoint && !token) {
        console.warn(`⏳ Waiting for token before calling ${path}...`);
        try {
            await waitForToken();
        } catch (err) {
            console.error("❌ No token available, cannot call API:", path);
            throw new Error("Unauthorized: Missing authentication token");
        }
    }

    const headers = { "Content-Type": "application/json" };
    if (token) headers["Authorization"] = `Bearer ${token}`;

    const fetchOptions = { method, headers };
    if (body && ["POST", "PUT", "PATCH", "DELETE"].includes(method)) {
        fetchOptions.body = JSON.stringify(body);
    }

    try {
        const response = await fetch(url, fetchOptions);

        if (!response.ok) {
            const errorText = await response.text();

            // If the backend sent 401 (expired token), trigger logout
            if (response.status === 401) {
                console.warn("🔒 Token expired, logging out...");
                logout();
                return; // Stop further processing
            }

            // Otherwise throw a normal error
            throw new Error(`HTTP ${response.status}: ${errorText}`);
        }

        const data = await response.json().catch(() => null);
        return data;
    } catch (err) {
        console.error(`❌ API error at ${url}:`, err);
        throw err;
    }

}
